// Rangy editor functionality

document.addEventListener('turbo:load', () => {
  // Reset rangy for editor with Turbo
  if (window['rangy']) {
    window['rangy'].initialized = false
  }
})
